import { render, staticRenderFns } from "./Hotline.vue?vue&type=template&id=358f9ecd&scoped=true&"
import script from "./Hotline.vue?vue&type=script&lang=ts&"
export * from "./Hotline.vue?vue&type=script&lang=ts&"
import style0 from "./Hotline.vue?vue&type=style&index=0&id=358f9ecd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f9ecd",
  null
  
)

export default component.exports